import { StatusChip } from '@/components/admin/ui';
import type { AdminTone } from '@/components/admin/ui/status';
import { jobPaymentLabel, type JobPaymentFields, type PaymentTone } from '@/lib/bookingPayment';

const TONE: Record<PaymentTone, AdminTone> = {
  green: 'green',
  amber: 'amber',
  grey: 'grey',
  violet: 'violet',
  red: 'rose',
};

/**
 * "Deposit paid £18" / "Paid in full" / "Cash on the day" / "Awaiting payment
 * (expires 14:32)" for an online booking; nothing for other jobs.
 */
export function JobPaymentChip({
  job,
  symbol,
  timeZone,
  className,
}: {
  job: JobPaymentFields;
  symbol?: string;
  timeZone?: string;
  className?: string;
}) {
  const meta = jobPaymentLabel(job, { symbol, timeZone });
  if (!meta) return null;
  return (
    <StatusChip tone={TONE[meta.tone]} className={className} data-testid="job-payment-chip">
      {meta.label}
    </StatusChip>
  );
}
